import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Arrondis par role (cf --radius-* dans src/styles/theme.css) : declares pour
// que cn() les fusionne avec rounded-xl, rounded-full, etc.
const twMerge = extendTailwindMerge({
  extend: { theme: { radius: ['button', 'field', 'chip', 'badge'] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
